import { ContactConfig } from '../../contact.types';

export default {
  headerText:
    'EUA users should reset password or recover account via Enterprise User Administration (EUA).',
  links: [
    {
      label:
        'Visit Enterprise User Administration (EUA) to reset password or recover account',
      link: 'https://eua.cms.gov/iam/im/pri/',
    },
  ],
  contactDetails: {
    email: 'CMS_IT_Service_Desk@cms.hhs.gov',
    phone1: '1-800-562-1963',
    phone2: '410-786-2580',
  },
  footerText: '',
} as ContactConfig;
